module.exports = __webpack_public_path__ + "static/course-details-coaches.13c283e5.png";